export const EXCLUDED_PATHS = [
  "/lp-nw/middle-east/bba",
  "/lp-nw/middle-east/all/ug-pg",
  "/lp-nw/middle-east",
  "/lp-nw/middleeast/mba",
  "/lp-nw/middle-east/mca",
  "/lp-nw/middle-east/bca",
  "lp-nw/middle-east/bba",
  "lp-nw/middle-east/all/ug-pg",
  "lp-nw/middle-east",
  "lp-nw/middleeast/mba",
  "lp-nw/middle-east/mca",
  "lp-nw/middle-east/bca",
  "/certifications"
];

export const precedentTimer = (path = "") => {
  if (path.includes("/blog")) return 10000;
  else return 30000;
};
